export default __webpack_public_path__ + "static/media/soccerPlayer.46462d31.jpeg";